import React from 'react';
import { 
  Box,
  Badge,
  makeStyles
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
// import Badge from '@material-ui/icons/Badge';

const useStyles = makeStyles((theme) => ({
  dot: {
    color: "#DD425A",
  }
}));

const NoticeBell = () => {
  const classes = useStyles();
  return (
    <Box sx={{ color: 'action.active' }}>
      <Badge color="error" variant="dot">
        <NotificationsNoneIcon />
      </Badge>
  </Box>
  );
}

export default NoticeBell;
